export const getHomePath = () => {
  return "/";
};
